<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'首页推荐管理管理'},{name:'平台热点管理列表',goback:true},{name:'添加平台热点'}]" :title="'添加平台热点'"/>
            <!-- 表单 -->
            <div class="box">
                <div class="forms">
                    <el-form
                        :model="ruleForm"
                        :rules="rules"
                        ref="ruleForm"
                        label-width="100px"
                        class="demo-ruleForm"
                      >
                        <el-form-item
                          label="资讯名称"
                          prop="advisoryId"
                          class="formitem"
                        >
                          <el-select
                            v-model="ruleForm.advisoryId"
                            placeholder="请选择资讯名称"
                            filterable
                            clearable
                          >
                            <el-option
                              :label="item.title"
                              :value="item.id"
                              v-for="(item,index) in newsDataSelect"
                              :key="index"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                       
                        <el-form-item
                          label="序号"
                          prop="sort"
                        >
                          <el-input
                            v-model="ruleForm.sort"
                            placeholder="请输入"
                            maxlength="10"
                          ></el-input>
                        </el-form-item>
                        <el-form-item>
                          <el-button type="primary" size="small" @click="submitForm('ruleForm')">确认</el-button>
                          <el-button size="small" @click="resetForm('ruleForm')">取消</el-button>
                        </el-form-item>
                      </el-form>
                </div>
            </div>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
import upLoad from '../../components/upLoad'
import {getDict} from "@/axios";
export default {
    components:{
        breadcrumb,
        upLoad
    },
    data(){
        return{
          type:'1',
            statusList: [],//服务类型
			id:'',
            ruleForm: {
                advisoryId: null,
                sort: null,
            },
            rules: {
                sort: [
                    { required: true, message: '请输入序号', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (this.$reg.numPint.test(value) == false) {
                                callback(new Error('请输入正整数'))
                            } else {
                                return callback()
                            }
                        },
                        trigger: 'blur',
                    },
                ],
                advisoryId: { required: true, message: '请选择咨询名称', trigger: 'change' }
            },
            newsDataSelect:[]
			
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        }
    },
	created() {
		// /backstage/sysDict/parentId
	
    const {id,type} = this.$route.params
    this.type = type || '1'
		if(id){
		    this.id=id;
			  this.ruleForm.sourceId=id;
			  // this.getDetail();
		}
    this.getSelect()
		
	},
   
    methods:{
      async getSelect() {
            const that = this
            const {code,data,msg} = await that.$axiosc.get(this.type==='1'?'/backstage/hotpoint/news/select':'/backstage/hotpoint/guide/select', {})
            if (code == 200) {
                    that.newsDataSelect = data || [];
                } else {
                    that.$alert(msg)
                }
            that.dialogAdd = true

        },
		getDetail(){
			this.$axiosc.get('backstage/intermediary/details/'+this.id).then((r)=>{
			    if(r.code==200){
			        this.dataInfo=r.data;
					let	sendInfo={
					    "intermediaryServiceId": r.data.id,//中介服务ID，编辑时必传
					    "logo": r.data.logo,
					    "name": r.data.name,//中介服务名称
					    "serviceType": r.data.serviceType,//服务类型
					    "summary": r.data.summary,//简介
					    "websiteLink": r.data.websiteLink,//网址链接
						contactPerson:r.data.contactPerson,//联系人
						contactNumber:r.data.contactNumber,//联系人电话
					}
					this.sendInfo=sendInfo;
			    }else{
			        this.$alert(r.msg)
			    }
			})
		},
        //提交
         submitForm(formName) {
            console.log(this.ruleForm)
            const that = this
            that.$refs[formName].validate((valid) => {
                if (valid) {
                    that.$axioscBody.post(that.type === '1' ? 'backstage/hotpoint/news/add' : 'backstage/hotpoint/guide/add', that.ruleForm).then(async (r) => {
                            if (r.code == 200) {
                                that.$message({
                                    type: 'success',
                                    message: r.msg
                                });
                                that.resetForm(formName)
                            } else {
                                that.$alert(r.msg)
                            }
                        })

                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
          this.ruleForm={
                advisoryId: null,
                sort: null,
            }
            this.$router.back(-1);
          // this.$refs[formName].resetField();
        },
    }
}
</script>

<style lang="scss" scoped>
.warp{
     height:96%;
     overflow-x: hidden;
     overflow-y: auto;
    .box{
        padding-top: 50px;
        .forms{
            max-width: 650px;
            margin: auto;
            .child{
                .content{
                    flex: 1;
					.el-textarea{
						width: 100% !important;
					}
                }
				/deep/ .el-select{
					width: 100% !important;
				}
				
				.name{
					width: 150px !important;
					text-align: right;
				}
            }
			.hint{
				padding-left: 100px;
			}
			.singleBtn{
				text-align: center;
			}
			.error{
				padding-left: 100px;
			}
        }
    }
}
</style>